/** Why an export failed, in pt-BR, by its error code. */
export const exportFailureText: Record<string, string> = {
  no_recordings: 'Não há gravações no intervalo.',
  too_many_segments: 'O intervalo tem trechos demais; exporte partes menores.',
  mp4_failed: 'Não foi possível unir os vídeos (formato mudou no intervalo?). Exporte em ZIP.',
  mp4_unavailable: 'Este servidor não gera MP4. Exporte em ZIP.',
  export_upload_failed: 'O envio ao armazenamento falhou. Gere a exportação de novo.',
  attempts_exhausted: 'Não foi possível gerar o arquivo.',
  internal: 'Não foi possível gerar o arquivo.',
};

const fallback = 'Não foi possível gerar o arquivo.';

/** The text of a failure code; unknown or absent codes read as a generic failure. */
export function exportFailure(code: string | null | undefined): string {
  if (code && Object.hasOwn(exportFailureText, code)) return exportFailureText[code] ?? fallback;
  return fallback;
}
